import { render } from "./LoginPassword.vue?vue&type=template&id=e5ec1218&scoped=true"
import script from "./LoginPassword.vue?vue&type=script&lang=js"
export * from "./LoginPassword.vue?vue&type=script&lang=js"

import "./LoginPassword.vue?vue&type=style&index=0&id=e5ec1218&lang=scss&scoped=true"
import "./LoginPassword.vue?vue&type=style&index=1&id=e5ec1218&lang=scss"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ec1218"]])

export default __exports__